(function () {
  function findUnselectedOption(sectionId) {
    var variantSelects = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    if (!variantSelects) return null;

    var selects = variantSelects.querySelectorAll('select.select__select');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].value === '') return selects[i];
    }
    return null;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

      var productForm = form.closest('product-form');
      if (!productForm) return;

      var sectionId = productForm.dataset.sectionId;
      var unselected = findUnselectedOption(sectionId);
      if (!unselected) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
      var errorMessage = productForm.querySelector('.product-form__error-message');
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = 'Please select a size before adding to bag.';
        errorWrapper.hidden = false;
      }

      unselected.focus();
    },
    true
  );
})();
